module.exports = __webpack_public_path__ + "media/images/links/gobierno-232a536d31d6f2eb4ec01e05e346c249.jpg";